import { Box, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { headingPrimaryFont, headingSecondaryFont, headingTertiaryFont, primaryColor, secondaryColorOne, secondaryColorThree, white } from "../config";
import img from '../resources/images/place_holder2.jpg'


const colors = [white, primaryColor, secondaryColorThree];

const randomColor = () => {
    return colors[Math.floor(Math.random() * colors.length)];
};

const thoughts = [
    {
        text: (
            <>
                <Text as='span' color={randomColor()}>
                    Inquire
                </Text>
                <Text as='span' color={randomColor()}>
                    &nbsp;&
                </Text>
                <Text as='span' color={randomColor()}>
                    &nbsp;Encounter
                </Text>
            </>
        ),
    },
    {
        text: (
            <>
                <Text as="span" color={randomColor()}>
                    What am
                </Text>
                <Text as="span" color={randomColor()}>
                    &nbsp;&quot;I&quot;
                </Text>
                <Text as="span" color={randomColor()}>
                    &nbsp;Being?
                </Text>
            </>
        ),
    },
    {
        text: (
            <>
                <Text as="span" color={randomColor()}>
                    In the
                </Text>
                <Text as="span" color={randomColor()}>
                    &nbsp;Changing
                </Text>
                <Text as="span" color={randomColor()} >
                    &nbsp;World....
                </Text>
            </>
        )
    },
    {
        text: (
            <>
                <Text as="span" color={randomColor()}>Creative</Text>
                <Text as="span" fontStyle={"italic"}
                    color={randomColor()}> &quot;I&quot;</Text>
                <br />
                in
                <br />
                <Text as="span" fontStyle={"italic"} color={randomColor()}> &quot;I&quot;</Text>
                <Text as="span" color={randomColor()}> don&apos;t know</Text>
            </>
        ),
    },
    {
        text: (
            <>
                <Text as="span" color={randomColor()}>Ask</Text>
                <Text as="span" fontStyle={"italic"}
                    color={randomColor()}> the</Text>
                <Text as="span" color={randomColor()}>&nbsp;Question!</Text>
            </>
        ),
    },
    {
        text: (
            <>
                <Text as="span" color={randomColor()}>What is the</Text>
                <Text as="span" fontStyle={"italic"}
                    color={randomColor()}> Legacy </Text>
                <br />
                <Text as="span" fontStyle={"italic"} color={randomColor()}> of My Time?</Text>
            </>
        ),
    },

];

const randomPosition = () => ({
    x: 18 + Math.random() * 64,
    y: 18 + Math.random() * 64,
});

interface Thought {
    text: React.ReactNode;
    position: { x: number; y: number };
}





export default function RandomQuestionField() {
    const remainingRef = useRef([...thoughts]);

    const [thought, setThought] = useState<Thought | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let timeout: NodeJS.Timeout;

        const showThought = () => {
            // Reset the pool once every thought has appeared.
            if (remainingRef.current.length === 0) {
                remainingRef.current = [...thoughts];
            }

            // Pick a random thought.
            const index = Math.floor(
                Math.random() * remainingRef.current.length
            );

            const nextThought = remainingRef.current.splice(index, 1)[0];

            setThought({
                ...nextThought,
                position: randomPosition(),
            });

            // Trigger CSS transition after mounting.
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setVisible(true);
                });
            });

            // Fade out.
            setTimeout(() => {
                setVisible(false);
            }, 2000);

            // Remove and show the next one.
            timeout = setTimeout(() => {
                setThought(null);
                showThought();
            }, 4000);
        };

        const initialTimeout = setTimeout(showThought, 1000);

        return () => {
            clearTimeout(initialTimeout);
            clearTimeout(timeout);
        };
    }, []);

    return (

        <Box
            h={{ base: "15rem", md: "30rem", lg: "45rem" }}
            minH={{ base: "10rem", md: "30rem", lg: "45rem" }}
            maxH={{ base: "40vh", md: "50vH" }}
            mb={"5rem"}
            position="relative"
            bg="#f0c89a" //d9c3aa
            color="#f5f0e7"
            fontFamily='Georgia, "Times New Roman", serif'
            // backgroundImage={img}
            bgRepeat={"no-repeat"}
            backgroundSize="cover"
        >
            {/* Background identifier */}
            <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                zIndex={1}
                fontFamily="Arial, sans-serif"
                fontSize={{ base: headingPrimaryFont, md: "3rem", lg: "4rem" }}
                fontWeight={700}
                letterSpacing="-0.08em"
                opacity={0.25}
                pointerEvents="none"
                userSelect="none"
                // fontFamily={'Brush Script MT'}
                color={primaryColor}
            >
                <Text as="span" >
                    SwaDharma S
                </Text>
                <Text as="span" color={secondaryColorThree}>
                    P
                </Text>
                andana
            </Box>

            {/* Floating inquiry */}
            {thought && (
                <Box
                    position="absolute"
                    left={`${thought.position.x}%`}
                    top={`${thought.position.y}%`}
                    maxW="min(650px, 70vw)"
                    fontSize={{
                        base: "27px",
                        md: "clamp(24px, 3.2vw, 46px)",
                    }}
                    lineHeight="1.15"
                    fontWeight="normal"
                    textAlign="center"
                    pointerEvents="none"
                    opacity={visible ? 1 : 0}
                    transform={
                        visible
                            ? "translate(-50%, -50%) scale(2)"
                            : "translate(-50%, -50%) scale(0.5)"
                    }
                    transition="opacity 2.5s ease, transform 2s ease"
                >
                    {thought.text}
                </Box>
            )}
        </Box>

    );
}
